import React, { memo } from 'react'
import { Handle, Position } from '@xyflow/react'

const ActionNode = memo(({ data, selected }) => {
    const hasType = !!data.actionType
    const params = data.actionParams || {}
    const paramKeys = Object.keys(params).filter((k) => params[k])

    return (
        <div className={`wf-node wf-node-action ${selected ? 'wf-node-selected' : ''}`}>
            <div className="wf-node-header wf-node-header-action">
                <i className="fa fa-play" /> Action
            </div>
            <div className="wf-node-body">
                {hasType ? (
                    <>
                        <div className="wf-node-title">
                            {data.actionType.replaceAll('_', ' ').toUpperCase()}
                        </div>
                        {paramKeys.length > 0 && (
                            <div className="wf-node-list">
                                {paramKeys.slice(0, 2).map((k) => (
                                    <div key={k} className="wf-node-list-item wf-node-list-item-small">
                                        <span className="wf-cond-field">{k}:</span>{' '}
                                        <span className="wf-cond-val">
                                            {String(params[k]).length > 25
                                                ? String(params[k]).slice(0, 25) + '...'
                                                : String(params[k])}
                                        </span>
                                    </div>
                                ))}
                                {paramKeys.length > 2 && (
                                    <div className="wf-node-more">+{paramKeys.length - 2} more params</div>
                                )}
                            </div>
                        )}
                    </>
                ) : (
                    <div className="wf-node-placeholder">Click to configure action</div>
                )}
            </div>
            <Handle type="target" position={Position.Top} className="wf-handle" />
        </div>
    )
})

ActionNode.displayName = 'ActionNode'
export default ActionNode
